import {
  CardData,
  CategoryDef,
} from "api/interfaces/dashboardInterface.interface";
import ChartWrapper from "../graph/ChartWrapper";
import { getDashboardVideoShare } from "api/widgetAPI";
import useStatsData from "hook/useStatsData";

export default function VideoShare(props: CardData) {
  const { statsData, data, legend, interval, setInterval } = useStatsData({
    queryFn: getDashboardVideoShare,
    queryName: "statsVideoShare",
    items: props.items as CategoryDef[],
  });
  return (
    <ChartWrapper
      rows={data}
      items={props.items as CategoryDef[]}
      onChangeInterval={setInterval}
      interval={interval}
      isLoading={statsData.isLoading}
      legend={legend}
      areaOpacity={0.1}
    />
  );
}
